import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './designs/fontFaces';
import './styles/base.css';
import './components/ui/ui.css';
import { App } from './app/App';
import { registerServiceWorker } from './app/sw-register';
import { store } from './state/store';

void store.init();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
